<template>
  <div class="c-material-report">
    <report-filter ref="filter" @on-change="filterData" @on-search="searchFilterData" @on-change-cols="dimCols = $event" />
    <div class="c-m-table">
      <div class="c-table-list">
        <QueryParamsManager
          ref="queryParamsManager"
          menu-id="M21076"
          :max-conditions="20"
          @select="onConditionSelect"
          @request-save="onSaveRequest"
        />
        <div class="right-btns">
          <div class="empty-data-filter">
            <el-switch v-model="emptyFilterSwitch" @change="$refs.filter.sendEvent()"></el-switch>
            <span>&ensp;过滤消耗为0数据</span>
          </div>
          <el-radio-group class="date-type-radio" v-model="dateType" @change="handlerDateType">
            <el-radio-button :label="DATE_TYPE.DAY">分日</el-radio-button>
            <el-radio-button :label="DATE_TYPE.WEEK">分周</el-radio-button>
            <el-radio-button :label="DATE_TYPE.MONTH">分月</el-radio-button>
            <el-radio-button :label="DATE_TYPE.TOTAL">汇总</el-radio-button>
          </el-radio-group>

          <div class="date-picker-wrapper">
            <DateRangePicker
              v-if="dateType === 1 || dateType === 4"
              v-model="datetime"
              style="width: 220px"
              :clearable="false"
              :pickerOptions="{ disabledDate }"
              @change="onDateRangeChange"
            ></DateRangePicker>

            <div>
              <dateWeekRange
                v-if="dateType === 2"
                v-model="weekRange"
                range-separator="至"
                style="width: 180px"
                start-placeholder="开始周"
                end-placeholder="结束周"
                :default-value="WeekDefaultShow"
                :picker-options="weekOptions"
                @change="onDateRangeChange"
                popper-class="week-range"
              >
              </dateWeekRange>
            </div>
            <div>
              <el-date-picker
                v-if="dateType === 3"
                v-model="monthRange"
                type="monthrange"
                range-separator="至"
                style="width: 180px"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :default-value="MonthDefaultShow"
                :picker-options="monthOptions"
                @change="onDateRangeChange"
              >
              </el-date-picker>
            </div>
          </div>

          <Button @click="modalColumn = true">自定义列</Button>
          <Button icon="md-download" style="margin-left: 5px" @click="downData" :loading="exportLoading">数据导出</Button>
        </div>
      </div>
      <Viewport v-model="tableHeight">
        <p-detail-table
          ref="planDataTable"
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :columns="tableCols"
          :summary="summaries"
          @on-sort="sortTable"
          @on-show="handleShow"
          @header-dragend="headerDragend"
          @on-refresh="getData"
        />

        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSizePrivate"
          :page-sizes="[10, 20, 30, 40, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSizePrivate"
          class="c-table-page pager"
          background
        />
      </Viewport>
    </div>

    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="modalColumn"
      name="douyinAwemeCustomColumn"
      :data="rawTableCols"
      :sub-title="['基础信息', '报表数据', '留存数据']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { isArray, isEmpty, deepCopy } from '@/common/js/utils'
import mixinTable from '../comprehension-report/js/mixin_table.js'
import { complexRestCols } from './data/effect_column.js'
import CustomColumn from '@/components/converter/custom-column2.vue'
import QueryParamsManager from '@/components/query-params-manager/index.vue'
import ReportFilter from './components/report-filter.vue'
import PDetailTable from './components/effect-table'

import DateRangePicker from '@/components/date-range-picker/index.vue'

import { getDouyinComplexReport, countDouyinReportData, exportDouyinReportData } from '@/api/report.model'

import { toThousands, toPercentFixed } from '@/common/js/filters'
import { thousands } from '../comprehension-report/js/judge-table.js'

const DATE_TYPE = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
  TOTAL: 4
}
export default {
  name: 'awemecomplex',
  mixins: [mixinTable],
  components: { CustomColumn, PDetailTable, QueryParamsManager, ReportFilter, DateRangePicker },
  computed: {
    permission() {
      return this.$store.state.accessAuth || []
    },

    tableCols() {
      const firstCol = {
        title: this.getDateType(this.dateType),
        key: 'tdate',
        type: 'disabled',
        width: 100,
        fixed: true
      }

      // v4.22.1 为分日分周分月新增排序
      if ([DATE_TYPE.DAY, DATE_TYPE.WEEK, DATE_TYPE.MONTH].includes(this.dateType)) {
        firstCol.sortable = 'custom'
      }
      const dimensionCols = this.dimCols.map((col) => {
        return { ...col, type: 'disabled' }
      })
      const addCols = [firstCol, ...dimensionCols]
      const tableColumns = this.tableColumns.filter((c) => {
        // 当分周、分月日期类型时，不显示新创角累计天数
        if ([DATE_TYPE.WEEK, DATE_TYPE.MONTH].includes(this.dateType)) {
          return c.checked && c.title !== '新创角累计天数'
        }
        return c.checked
      })
      console.log(addCols)

      return [...addCols, ...tableColumns]
    }
  },
  methods: {
    query() {
      this.$refs.filter.sendEvent()
    },
    handlerDateType(val) {
      switch (val) {
        case DATE_TYPE.WEEK:
          {
            // 默认周一到周天
            let monday = moment().weekday(0)
            let lastday = moment().weekday(6)
            // v4.22.1 如果今天是星期一，取上周一到上周天
            if (moment().day() === 1) {
              monday = moment().weekday(-7)
              lastday = moment().weekday(-1)
            }
            this.weekRange = [monday.format('YYYY-MM-DD'), lastday.format('YYYY-MM-DD')]
          }
          break

        case DATE_TYPE.MONTH:
          {
            // v4.22.1 例如今天是1月1日，则选中的是上月
            // 例如今天是1月2日，则选中的是本月
            let month = moment().format('YYYY-MM-01')
            const today = moment().format('YYYY-MM-DD')
            if (today.endsWith('-01')) {
              month = moment().subtract(1, 'month').format('YYYY-MM-DD')
            }
            this.monthRange = [month, month]
          }
          break

        default:
          break
      }

      this.query()
    },
    disabledDate(date) {
      return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
    },

    onDateRangeChange(v) {
      this.query()
    },
    getDateType(dateType) {
      let title
      switch (dateType) {
        case DATE_TYPE.DAY:
          title = '分日'
          break
        case DATE_TYPE.WEEK:
          title = '分周'
          break
        case DATE_TYPE.MONTH:
          title = '分月'
          break
        case DATE_TYPE.TOTAL:
          title = '汇总'
          break
      }
      return title
    },
    filterData(params, dimens) {
      this.addOnDimensions = dimens

      this.pageIndex = 1
      this.tableList = []
      this.getData(params)
    },
    getData(filter) {
      if (this.loading) return
      const [beginDate, endDate] = this.datetime || []
      let dates = { beginDate, endDate }

      if (this.dateType === 2) {
        const [b, e] = this.weekRange.map((d) => moment(d).format('YYYY-MM-DD'))

        dates = { beginDate: b, endDate: e }
      }

      if (this.dateType === 3) {
        const [b, e] = this.monthRange.map((d) => moment(d).format('YYYY-MM-DD'))
        dates = { beginDate: b, endDate: e }
      }

      let params = {
        ...dates,
        pageIndex: this.pageIndex,
        pageSize: this.pageSizePrivate,
        sort: this.sort,
        order: this.order,
        dateType: this.dateType,
        limitConsumption: this.emptyFilterSwitch ? 1 : 0
      }

      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getDouyinComplexReport(params).then((data) => {
        this.loading = false
        const { list, page_info, sum_data } = data || {}
        sum_data && (this.sumdata = sum_data)
        list && (this.tableList = list)
        if (page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
        } else this.tableList = []
        this.$nextTick(() => {
          this.$refs.planDataTable && this.$refs.planDataTable.doLayout()
        })
      })
    },
    downData() {
      const exportColumnOrderMap = {}
      this.tableCols.forEach((col) => {
        if ((col.checked || col.type === 'disabled') && !col.exclude_export) exportColumnOrderMap[col.key] = col.title
      })
      const params = Object.assign(this.params, {
        firstTime: new Date().getTime(),
        exportColumnOrderMap
      })
      this.exportLoading = true
      countDouyinReportData(params).then((res) => {
        if (res && res.isExport) {
          exportDouyinReportData(params).then((data) => {
            this.exportLoading = false
          })
        } else {
          this.exportLoading = false
          this.$message.warning('导出数量超出10W限制')
        }
      })
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (
          data[prop] &&
          (prop.indexOf('Rate') > -1 ||
            prop.indexOf('Retain') > -1 ||
            prop.indexOf('RoleRoi') > -1 ||
            ['createRoleTotalRoi'].includes(prop))
        ) {
          sums[index] = toPercentFixed(data[prop])
        } else if (thousands.includes(prop)) sums[index] = toThousands(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    handleShow(param) {
      const { key, row } = param
      let src
      if (key === 'imageName') {
        src = row.imageAddr
        const videoUrl = row.videoUrl
        const video = !isEmpty(videoUrl)
        this.$Gallery.open({ src, video, videoUrl })
      }
    },
    changePageSizePrivate(size) {
      this.pageSizePrivate = size
      if (this.pageIndex === 1) this.getData()
    },

    onSaveRequest() {
      this.$nextTick(() => {
        const params = this.$refs.filter.buildParams()
        this.$refs.queryParamsManager.openSaveDialog(params)
      })
    },
    onConditionSelect(cond) {
      if (this.$refs.filter && cond) {
        const { id, conditionInfo } = cond
        if (!isEmpty(conditionInfo)) {
          const { douyinNos, gameIds, gameGroupIds, platforms, order, sort } = JSON.parse(conditionInfo)
          !isEmpty(sort) && (this.sort = sort)
          !isEmpty(order) && (this.order = order)

          this.$nextTick(() => {
            Object.assign(this.$refs.filter, {
              douyinNos: douyinNos || [],
              gameIds: gameIds || [],
              gameGroupIds: gameGroupIds || [],
              platforms: platforms || []
            })
          })
        }
      }
    },
    onTableColsChange(cols) {
      this.modalColumn = false
      this.tableColumns = cols
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    }
  },
  data() {
    // 过滤掉没有权限的列
    const accessAuth = this.$store.state.accessAuth
    const cols = complexRestCols.filter((col) => !col.auth || accessAuth.includes(col.auth))
    return {
      datetime: [],
      weekRange: [],
      monthRange: [],
      addOnDimensions: [], // 查询时勾选的维度，获取结果后需要新增到表格列前面
      tableColumns: [],
      rawTableCols: cols,
      DATE_TYPE,
      tableHeight: 330,
      pageSizePrivate: 20, // 自定义默认页面尺寸
      tableList: [], // 表格数据
      sumdata: [], // 合计数据

      emptyFilterSwitch: false,
      gameLevelSettingModal: false, // 游戏等级通关率设置modal
      weekOptions: {
        firstDayOfWeek: 1,
        cellClassName: (date) => {
          if (date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24) return 'empty-date'
          return ''
        },
        disabledDate: (date) => {
          const isMonday = new Date().getDay() === 1
          if (isMonday) {
            return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
          }
          return date && date.valueOf() > Date.now() + (7 - new Date().getDay()) * 1000 * 60 * 60 * 24
        }
      },
      monthOptions: {
        disabledDate: this.disabledDate
      },
      dateType: 1,
      exportLoading: false,
      WeekDefaultShow: '',
      MonthDefaultShow: '',
      dimCols: []
    }
  },
  mounted() {
    this.WeekDefaultShow = new Date()
    this.MonthDefaultShow = new Date()
    this.WeekDefaultShow.setMonth(new Date().getMonth() - 1)
    this.MonthDefaultShow.setFullYear(new Date().getFullYear() - 1)
  },
  created() {
    const date = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.datetime = [date, date]
  }
}
</script>
<style lang="scss" scoped>
.c-material-report {
  height: 100%;

  .c-btn-group {
    line-height: 30px;
    height: 32px;
    border-radius: 3px;
    width: 100px;
    display: inline-block;
    vertical-align: middle;
  }

  // 游戏等级通关率设置
  ::v-deep .game-level-modal {
    .el-dialog__body {
      padding-bottom: 0;
    }
    .game-level-form {
      max-height: 370px;
      overflow: auto;
      padding-right: 5px;
    }

    .add-row {
      margin-left: 74px;
    }
    .title-row {
      display: flex;
      background: #f6f6f6;

      h3 {
        padding: 0 10px;
        font-size: 14px;
        font-weight: 600;

        &:nth-of-type(1) {
          min-width: 130px;
        }
        &:nth-of-type(2) {
          min-width: 130px;
        }
        &:nth-of-type(3) {
          min-width: 190px;
        }
      }
    }

    .game-row {
      display: flex;
      justify-content: space-between;
      .selector {
        display: flex;
        .el-select {
          flex: 1;
          margin-right: 5px;
        }
        .el-input {
          flex-basis: 25%;
        }
        .suffix {
          flex-basis: 5%;
        }
      }

      .btns {
        span {
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
  }

  .c-table-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    .right-btns {
      display: flex;
      align-items: center;
      .empty-data-filter {
        margin-right: 5px;
        display: flex;
        align-items: center;
      }

      .date-type-radio {
        margin-right: 5px;
      }
      .date-picker-wrapper {
        margin-right: 5px;
      }

      .week-range .el-date-table th {
        text-align: center;
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
<style lang="scss">
.week-range {
  // 当周今天和之后的日期样式置灰
  .empty-date {
    div {
      background-color: #f5f7fa;
      cursor: not-allowed;
      color: #c0c4cc;
    }
    span {
      color: #c0c4cc !important;
      font-weight: normal !important;
    }
  }
}
</style>
